module.exports = {
  searchPlaceholder: 'Search...',
  findCategory: 'Find Category',
  addCategory: 'Add another category',
  optionalFindCategory: 'Choose a secondary category (optional)',
  categoryLabel: 'Category*',
};
